import React from 'react';
import FileSystem from './FileSystem';

import { ls, cd, open, pwd, cat, touch, rm, sh } from './commands/dir'

class Terminal {
  constructor(app) {
    this.outputs = [];
    this.hist = [];
    this.queue = [];
    this.currentUser = 'didrik';
    this.currentHost = 'didrik.tech';
    this.currentDirectory = ['projects', 'didrik.tech'];
    this.fs = new FileSystem();

    this.commands = {
      ls,
      cd,
      open,
      pwd,
      cat,
      touch,
      rm,
      sh,

      dir: (args, terminal, app) => {
        if(!app.execute) {
          return (<div>dir: current terminal does not support execution</div>);
        }

        return app.execute(args);
      },

      restart: (args, terminal, app) => {
        app.state.terminal = new Terminal(app);
        return null;
      },

      clear: () => {
        this.outputs = [];
        return null; // null when you don't want the history printed
      },

      reset: (args, terminal) => {
        terminal.fs.format().save();
        terminal.queue.push({
          query: 'restart',
          clear: true,
        });
        return null;
      },
    };
  }

  // to be called when parent component is mounted
  startup(app) {
    let startup = this.fs.ls(['sys', 'startup.conf']);
    if(startup && startup.status === 'isfile') {
      this.execute(startup.content, app);
    }
  }

  getDirectory(dir=this.currentDirectory) {
    let directory = '';
    for(let i in dir) {
      directory += '/' + dir[i];
    }
    return directory;
  }

  logHist(query) {
    if(query === '') return;
    
    this.hist.push(query);
    let hist = this.fs.ls(['sys', 'hist.log']);
    if(hist.status !== 'isfile') {
      let sys = this.fs.ls(['sys']);
      if(sys.status === 'isdir') {
        sys.content['hist.log'] = {
          type: 'file',
          content: '',
        };
      }
    }
    this.fs.write(['sys', 'hist.log'], hist.content + query + '\n');
  }

  execute(query, app, clear) {
    if(app) {
      app.setTyping(false);
    }

    this.queue.push({ query, clear });

    if(this.queue.length === 1) {
      this.executeQueries(app); 
    }
  }

  executeCmd(cmd, app) {
    let result;
    if(cmd[0] === '') {
      result = (<div></div>);
    } else if(this.commands[cmd[0]]) {
      result = this.commands[cmd[0]](cmd, this, app);
    } else {
      result = (<div>{cmd[0]}: command not found</div>);
    }

    let obj = {};
    if(!result) {
      obj.toPrint = null;
    } else if(!result.toPrint) {
      obj.toPrint = result;
    } else {
      obj = {
        toPrint: result.toPrint,
        promise: result.promise
      };
    }

    app.updateTerminal();

    return {
      status: result === null ? 'clear' : 'print',
      toPrint: obj.toPrint,
      promise: obj.promise
    };
  }

  executeQueries(app) {
    let currentQuery = this.queue.shift();
    let splitted = currentQuery.query.split('&&');

    if(splitted.length > 1) {
      this.queue = splitted.map(a => {
        return {
          query: a,
          clear: true,
        };
      }).concat(this.queue);
    }

    if(!currentQuery.clear) {
      this.logHist(currentQuery.query);
    }

    if(splitted.length <= 1) {
      let promises = this.executeQuery(currentQuery.query, app, currentQuery.clear);
      let terminal = this;

      Promise.all(promises).then(() => {
        if(this.queue.length > 0) {
          terminal.executeQueries(app);
        } else if(app) {
          app.setTyping(true);
        }
        app.updateTerminal();
      });
    } else {
      this.executeQuery(currentQuery.query, app, currentQuery.clear, true);
      this.executeQueries(app);
    }
  }

  // clear = avoid printing history
  executeQuery(query, app, clear, ignoreExecute) {
    let toPrint = [];
    let doPrintHistory = true;
    let promises = [];

    let currentDirectory = this.currentDirectory;
    let currentHost = this.currentHost;
    let currentUser = this.currentUser;

    let trim = a => a.trim().split(' ').map(b => b.trim());

    if(!ignoreExecute) {
      query.split(';').map((a, i) => {
        let cmd = trim(a);

        if(!this.commands[cmd[0]]) {
          let alias = this.fs.ls(['sys', 'alias.conf']);
          if(alias && alias.status === 'isfile') {
            alias.content.split('\n').map(b => {
              let splitted = b.split(': ');
              let key = splitted[0];
              if(key === cmd[0]) {
                cmd = trim(splitted[1]);
              }
              return b; // array-callback-return
            });
          }
        }

        let result = this.executeCmd(cmd, app);
        promises.push(result.promise);

        if(result.status === 'clear' && !clear) {
          toPrint = [];
          doPrintHistory = false;
        } else {
          toPrint.push((<div key={i} className={'cmd-' + cmd[0]}>{ result.toPrint }</div>));
        }

        if(clear) {
          doPrintHistory = false;
        }

        return a; // array-callback-return
      });
    } else {
      toPrint.push(<div key={1}></div>);

    }

    this.outputs.push({
      print: toPrint,
      query: query,
      directory: currentDirectory,
      host: currentHost,
      user: currentUser,
      doPrintHistory,
      promises,
    });

    this.fs.save();

    return promises;
  }
}

export default Terminal;


// WEBPACK FOOTER //
// ./src/Terminal.js